import React, { useState, useEffect, useRef } from "react";
import { TextField, Button, Checkbox, FormControlLabel, Radio, RadioGroup, FormControl, FormLabel, Select, MenuItem, Typography, Grid, Menu, Box, Avatar, Tooltip, Divider, IconButton, Modal, InputAdornment, InputLabel, Autocomplete, CircularProgress } from "@mui/material";
import RestAPIService from "../../Utility/Services/RestAPIService";
import { Serviceurls } from "../../Utility/API/Serviceurls";
import CommonValidation from "../../Components/CommonFunctions/CommonValidation";
import { removeHyphen, removeSpaces } from '../../Components/CommonFunctions/CommonFunctions';
import { DateTime } from "luxon";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import {ImagePaths} from "../../Utility/ImagePaths";
import { CommonPatientDetails, ConfirmPopup } from "../../Components/Common Components/CommonComponents";
import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1';
import SearchIcon from "@mui/icons-material/Search";
import Loader from '../../Components/Loader'
import ToastMsg from "../../Components/ToastMsg/ToastMsg";
import { debounce } from "@mui/material/utils";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import RefreshIcon from '@mui/icons-material/Refresh';
import { localGetItem } from "../../Utility/Services/CacheProviderService";

const AbhaRegister = (props) => {
    const [registrationType, setRegistrationType] = useState("new");
    const [verifyWith, setVerifyWith] = useState("AADHAAR");
    const [patientType, setpatientType] = useState("New");
    const [searchPatient, setsearchPatient] = useState("");
    const [PatientID, setPatientID] = useState(null);
    const [searchPatientData, setSearchPatientData] = useState([])
    const [aadhaar, setAadhaar] = useState("");
    const [otp, setOtp] = useState("");
    const [CurrentTxnId, setCurrentTxnId] = useState("");
    const [termsAccepted, setTermsAccepted] = useState(false);
    const [otpSent, setOtpSent] = useState(false);
    const [otpVerified, setOtpVerified] = useState(false);
    const [patientData, setPatientDetails] = useState(null);
    const [mobile, setMobile] = useState("")
    const [VerifyInput, setVerifyInput] = useState("")
    const [copiedField, setCopiedField] = useState("");
    const [seachedPatient, setPatientName] = useState("")
    const [isLoader, setLoader] = useState(false)
    const [isErrorStatus, setErrorStatus] = useState(false)
    const [errorMsg, setErrorMsg] = useState("")
    const [btnDisable, setBtnDisable] = useState(false)
    const [isSuccStatus, setSuccStatus] = useState(false)
    const [succMsg, setSuccMsg] = useState("")
    const [isRegistered, setIsRegistered] = useState(false)
    const [popupData, setPopupData] = useState(null)
    const [resendCount, setResendCount] = useState(0)
    const [counter, setCounter] = useState(0);
    const timerRef = useRef(null);
    const timerRef2 = useRef(null);
    const [suggetionPop, setSuggetionPop] = useState(false);
    const [suggetionData, setSuggetionData] = useState(null);
    const [customAddress, setCustomAddress] = useState("");
    const [selectedSuggestion, setSelectedSuggestion] = useState(null);
    const [addressApproved, setAddressApproved] = useState(false);
    const [aadhaarMasked, setAadhaarMasked] = useState(true);
    const [addressAvailable, setAddressAvailable] = useState(null); // null | true | false
    const [addressCheckLoading, setAddressCheckLoading] = useState(false);
    const [termsPopupOpen, setTermsPopupOpen] = useState(false);
    const [termsChecks, setTermsChecks] = useState([false, false, false, false, false, false, false]); // adjust length for your terms
    const [captcha, setCaptcha] = useState('');
    const [captchaInput, setCaptchaInput] = useState('');
    const [termsStepperStep, setTermsStepperStep] = useState(0);
    const [adhaarMobMsg, setAdhaarMobMsg] = useState("OTP sent to Aadhaar registered mobile number");
    const [comMob2, setComMob2] = useState(false);
    // const [comMobTxnId, setComMobTxnId] = useState("");
    const [comMobMsg, setComMobMsg] = useState("OTP sent to Aadhaar registered mobile number");
    const [otp2, setOtp2] = useState('');
    const [otpSent2, setOtpSent2] = useState(false);
    const [counter2, setCounter2] = useState(0);
    const [resendCount2, setResendCount2] = useState(0);
    const [agreeName, setAgreeName] = useState("");
    const [customNameError, setCustomNameError] = useState("")
    const [aadhaarError, setAadhaarError] = useState(false)
    const [alertPopup, setAlertPopup] = useState(false)

    const loginName = localGetItem("LogedUserName") ? localGetItem("LogedUserName") : ""

    useEffect(() => {
        if (otpSent && counter === 0) {
            setCounter(59);
        }else if (otpSent2 && counter2 === 0) {
            setCounter2(59);
        }
    }, [otpSent, otpSent2]);

    useEffect(() => {
        if (counter > 0) {
            timerRef.current = setTimeout(() => setCounter(counter - 1), 1000);
        }else if (counter2 > 0) {
            timerRef2.current = setTimeout(() => setCounter2(counter2 - 1), 1000);
        }
        return () => clearTimeout(timerRef.current);
    }, [counter, counter2]);

    useEffect(() => {
    return () => {
        debouncedCheckAddress.cancel && debouncedCheckAddress.cancel();
    };
    }, []);

    useEffect(() => {
        setCaptcha(generateCaptcha());
    }, []);

    const checkCustomAddressAvailability = async (address) => {
        if (!address) {
            setAddressAvailable(null);
            return;
        }
        setAddressCheckLoading(true);
        try {
            // Replace with your actual API call and logic
            const response = await RestAPIService.create(
                { abha_address: address },
                Serviceurls.ABHA_CUSTOM_ADDRESS_AVAILABILITY
            );
            setAddressAvailable(response?.data?.available === true);
        } catch (e) {
            setAddressAvailable(false);
        }
        setAddressCheckLoading(false);
    };

    const debouncedCheckAddress = useRef(
        debounce(checkCustomAddressAvailability, 300)
    ).current;

    const handleCopy = (value, field) => {
        navigator.clipboard.writeText(value).then(() => {
            setCopiedField(field);
            setTimeout(() => setCopiedField(""), 2000); // Reset copied state after 2s
        });
    };
    const generateCaptcha = (length = 6) => {
        const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
        let result = '';
        for (let i = 0; i < length; i++) {
            result += chars.charAt(Math.floor(Math.random() * chars.length));
        }
        return result;
    }

    const openTermsPopup = () => {
        // setTermsChecks([false, false, false, false, false]);
        // setCaptcha(generateCaptcha());
        // setCaptchaInput('');
        setTermsPopupOpen(true);
    };

    const handleAadhaarChange = (e) => {
        let value = e.target.value.replace(/\D/g, "").slice(0, 12);
        value = value.replace(/(\d{4})/g, "$1 ").trim();
        setAadhaar(value);
        setAadhaarError(false);
    };

    const handleVerifyInputChange = (value) => {
        if (verifyWith === "AADHAAR") {
            value = value.replace(/\D/g, "").slice(0, 12);
            value = value.replace(/(\d{4})/g, "$1 ").trim();
            setVerifyInput(value)
        } else {
            if (CommonValidation.numberOnly(value) || (value === "")) {
                setVerifyInput(value)
            }
        }
    }

    const handleMobileChange = (value) => {
        if (CommonValidation.numberOnly(value) || (value === "")) {
            setMobile(value)
        }
    }

    const errorMessage = (message) => {
        setErrorStatus(true)
        setErrorMsg(message)
        setBtnDisable(false)
    }

    const successMessage = (message) => {
        setSuccMsg(message)
        setSuccStatus(true)
    }

    const msgClose = () => {
        setErrorStatus(false)
        setErrorMsg('')
        setSuccMsg('')
        setSuccStatus(false)
    }

    const formAllClear = () => {
        setAadhaar(alertPopup ? aadhaar : "")
        setOtp("")
        setCurrentTxnId("")
        setTermsAccepted(false)
        setOtpSent(false)
        setOtpVerified(false)
        setPatientDetails(null)
        setMobile("")
        setVerifyInput("")
        setCopiedField("")
        setPatientID(null)
        setsearchPatient("")
        setSearchPatientData([])
        setPatientName("")
        setpatientType("New")
        setVerifyWith("AADHAAR")
        setRegistrationType("new")
        setLoader(false)
        setBtnDisable(false)
        setIsRegistered(false)
        setPopupData(null)
        setCounter(0);
        setSuggetionPop(false);
        setSuggetionData(null);
        setCustomAddress("");
        setResendCount(0);
        setSelectedSuggestion(null);
        setAddressApproved(false);
        setAddressAvailable(null);
        setAddressCheckLoading(false);
        setTermsPopupOpen(false);
        setTermsChecks([false, false, false, false, false, false, false]);
        setCaptcha(generateCaptcha());
        setCaptchaInput('');
        setAadhaarMasked(true);
        setTermsStepperStep(0);
        setAdhaarMobMsg("OTP sent to Aadhaar registered mobile number");
        setComMob2(false);
        // setComMobTxnId("");
        setOtp2('');
        setOtpSent2(false);
        setCounter2(0);
        setResendCount2(0);
        setAgreeName("")
        setCustomNameError("")
        setAlertPopup(false)
    }

    const handleGenerateOtp = (resend=0, type="") => {
        try {
            setLoader(true)
            setBtnDisable(true)
            var data = {}
            var URL = Serviceurls.ABHA_AADHAAR_OTP_REQUEST
            if(type === "comMob2") {
                data = {
                    "mobile": mobile,
                    "mobile_verify": true,
                    "transaction_id": CurrentTxnId ? CurrentTxnId : "",
                }

            } else{
                var Aadhaar = removeSpaces(aadhaar)
                data = {
                    "aadhaar_number": Aadhaar
                }

            } 

            RestAPIService.create(data, URL)
                .then(response => {
                    setLoader(false)
                    setBtnDisable(false)
                    if (response?.data?.status == "success") {
                        var Data = response?.data?.data
                        if(type === "comMob2") {
                            // setComMobTxnId(Data?.txnId)
                            setComMob2(true)
                            setOtpSent2(true);
                            setCounter2(59);
                            setCounter(0);
                            setResendCount2(resendCount2 + resend)
                            setComMobMsg(Data?.message || "OTP sent to Aadhaar registered mobile number");
                        }else {
                            setCurrentTxnId(Data?.txnId)
                            setOtpSent(true);
                            setCounter(59);
                            setResendCount(resendCount + resend)
                            successMessage(response.data?.data?.message || response.data?.message)
                            setAdhaarMobMsg(Data?.message || "OTP sent to Aadhaar registered mobile number");
                            setTermsStepperStep(1);
                        }
                    } else {
                        const apiError = response?.data?.content?.error?.message;
                        errorMessage(apiError || "Invalid Aadhaar Number");
                        setTermsPopupOpen(false);
                    }
                })
                .catch(e => {
                    setLoader(false)
                    setTermsPopupOpen(false);
                    if (e?.response?.data?.status === "fail") {
                        errorMessage("Invalid Aadhaar Number")
                    } else {
                        errorMessage("Invalid Aadhaar Number")
                    }

                })
        } catch (e) {
            errorMessage(e.message)
            setTermsPopupOpen(false);
        }
    };

    const handleVerifyOtp = (type) => {
        try {
            setLoader(true)
            setBtnDisable(true)
            var data = {}
            var URL = Serviceurls.ABHA_AADHAAR_OTP_VERIFY
            if (type === "comMob2") {
                data = {
                    "transaction_id": CurrentTxnId ? CurrentTxnId : "",
                    "mobile_number": mobile,
                    "otp": otp2,
                    "mobile_verify": true
                }
            } else {
                data = {
                    "transaction_id": CurrentTxnId ? CurrentTxnId : "",
                    "otp": otp,
                    "mobile_number": mobile
                }
            }

            RestAPIService.create(data, URL)
                .then(response => {
                    setLoader(false)
                    setBtnDisable(false)
                    if (response.data.status == "success") {
                        setOtpVerified(true);
                        if (type === "comMob2") {
                            setOtpVerified(true);
                            setTermsPopupOpen(false);
                            setSuggetionPop(true)
                            successMessage(response.data?.message)
                            getAbhasuggetion(response.data?.data)
                        } else if((mobile == response.data?.data?.mobile)) {
                        setTermsPopupOpen(false);
                        setPatientDetails(response?.data?.data)
                        setSuggetionPop(true)
                        successMessage(response.data?.message)
                        getAbhasuggetion(response.data?.data)
                        } else {
                            setPatientDetails(response?.data?.data)
                            handleGenerateOtp(0,"comMob2")
                        }
                    } else {
                        if(response?.data?.content?.error?.message === "UIDAI Error code : 400 : OTP validation failed"){
                            errorMessage("Please enter a valid OTP. Entered OTP is either expired or incorrect.")
                        }else{
                            errorMessage(response?.data?.content?.error?.message || response.data?.error?.message || response.data?.message)
                        }
                    }
                })
                .catch(e => {
                    setLoader(false)
                    if (e?.response?.data?.status === "fail") {
                        errorMessage(e.response?.data?.content?.error?.message || e.response?.data?.message)
                    } else {
                        errorMessage(e.response?.data?.content?.error?.message ||e.response?.data?.message || e.message)
                    }

                })
        } catch (e) {
            errorMessage(e.message)
        }
    };

    const getAbhasuggetion = (data) => {
        try {
            if (data?.txn_id || data?.txnId) {
                data = {
                    "transaction_id": data?.txn_id || data?.txnId,
                }
            }
             RestAPIService.create(data, Serviceurls.ABHA_PATIENT_ABHA_SUGGESTION)
                .then(response => {
                    if (response.data.status == "success") {
                        setSuggetionData(response.data?.data?.abhaAddressList || [])
                    } else {
                        errorMessage(response.data?.error?.message || response.data?.message)
                    }
                })
                .catch(e => {
                    if (e?.response?.data?.status === "fail") {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            errorMessage(e.message)
        }
    }

    const registerAbhaPatient = () => {
        try {
            setLoader(true)
            setBtnDisable(true)
            var DOB = patientData?.dob ? DateTime.fromFormat(patientData?.dob, "dd-MM-yyyy").toFormat("yyyy-MM-dd") : null
            var AbhaNum = patientData?.ABHANumber ? removeHyphen(patientData?.ABHANumber) : ""
            var data = {
                "dob": DOB,
                "first_name": patientData?.firstName,
                "mobile": patientData?.mobile,
                "middle_name": patientData?.middleName,
                "last_name": patientData?.lastName,
                "gender": patientData?.gender ? (patientData?.gender).toLowerCase() : "",
                "email": patientData?.email,
                "address": patientData?.address,
                "district": patientData?.districtName,
                "pincode": patientData?.pinCode,
                "state": patientData?.stateName,
                "abha_id": AbhaNum,
                "abha_address": patientData?.phrAddress[0],
                "link_hip": true,
                "from_register": true,
            }
            if (PatientID) {
                data['uhid'] = PatientID
            }
            RestAPIService.create(data, Serviceurls.ABHA_PATIENT_ABHA_REGISTER)
                .then(response => {
                    setLoader(false)
                    setBtnDisable(false)
                    if (response.data.status == "success") {
                        successMessage(response.data?.message)
                        setPopupData(response.data?.register_data ? response.data?.register_data : response.data?.data)
                        setIsRegistered(true)
                    } else {
                        errorMessage(response.data?.message)
                    }
                })
                .catch(e => {
                    setLoader(false)
                    if (e?.response?.data?.status === "fail") {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }

                })
        } catch (e) {
            errorMessage(e.message)
        }
    }

    const getPatientlist = () => {
        try {
            var search = searchPatient ? searchPatient : ""
            RestAPIService.getAll(Serviceurls.FO_PATIENT_SEARCH + `?search_key=${search}`)
                .then(response => {
                    if (response.data.status == "success") {
                        setSearchPatientData(response?.data?.data)
                    }
                })
                .catch(e => {
                    console.log("error", e)})
        } catch (e) {
            console.log("error2", e)
        }
    }

    const checkPatientAbhaLink = (patientID, list) => {
        try {
            setLoader(true)
            setBtnDisable(true)
            RestAPIService.getAll(Serviceurls.ABHA_PATIENT_HIP_LINK_CHECK + `?uhid=${patientID}`)
                .then(response => {
                    setLoader(false)
                    setBtnDisable(false)
                    if (response.data.status == "success") {
                        if (response.data?.data?.length > 0) {
                            errorMessage("Patient is already linked with ABHA")
                        } else {
                            setPatientID(list?.patient_account_number)
                            setPatientName(list?.patient_name)
                        }
                    } else {
                        errorMessage(response.data?.message)
                    }
                })
                .catch(e => {
                    setLoader(false)
                    setBtnDisable(false)
                    if (e?.response?.data?.status === "fail") {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            setLoader(false)  
            setBtnDisable(false)
            errorMessage(e.message)
        }
    }

    const downloadAbhaCard = () => {
        try {
            setLoader(true)
            var data = {
                "xtoken": patientData?.token,
                "txn_id": patientData?.txn_id
            }
            RestAPIService.create(data, Serviceurls.ABHA_PATIENT_ABHA_CARD_DOWNLOAD)
                .then(response => {
                    setLoader(false)
                    if (response) {
                        const file = new Blob(
                            [response.data],
                            { type: 'application/pdf' });
                        const fileURL = URL.createObjectURL(file);
                        window.open(fileURL);
                    } else {
                        errorMessage(response.data?.message)
                    }
                })
                .catch(e => {
                    setLoader(false)
                    if (e?.response?.data?.status === "fail") {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {   
            setLoader(false)
            setBtnDisable(false)
            errorMessage(e.message)
        }
    }

    const postCustomAddress = () => {
        try {
            setLoader(true) 
            setBtnDisable(true)
            var data = {
                "abha_address": customAddress,
                "transaction_id": patientData?.txn_id
            }
            RestAPIService.create(data, Serviceurls.ABHA_CUSTOM_ADDRESS_POST)
                .then(response => {
                    setLoader(false)
                    setBtnDisable(false)
                    if (response.data.status == "success") {
                        successMessage(response.data?.message)
                        setSuggetionPop(false)
                        setAddressApproved(true)
                        setPatientDetails({
                            ...patientData,
                            phrAddress: [(response.data?.data?.preferredAddress || response.data?.data?.preferredAbhaAddress)]
                        });
                    } else {
                        errorMessage(response.data?.content?.error?.message || response.data?.error?.message || response.data?.message)
                    }
                })
                .catch(e => {
                    setLoader(false)
                    setBtnDisable(false)
                    if (e?.data?.status === "fail") {
                        errorMessage(e.response?.data?.content?.error?.message || e.response?.data?.error?.message || e.response?.data?.message)
                    } else {
                        errorMessage(e.response?.data?.content?.error?.message || e.response?.data?.error?.message || e.response?.data?.message)
                    }
                })
        }catch (e) {
            errorMessage(e.message)
        }
    }

    const handleClose = () => {
        setAlertPopup(true);
    };

    const patientListPopup = () => {
        return (
        <Modal open={true}>
            <Box className="eMed_MobileNum_Main">
            <Box component={'div'} className="eMed_MobileNum_Header">
                <Typography variant='h6'>{"Patient List"}</Typography>
                <IconButton onClick={() => { setSearchPatientData([]) }} marginRight={'4vw'}>
                <img src={ImagePaths.LabCloseButton.default} alt="close" className='eMed_action_img_small' />
                </IconButton>
            </Box>
            <Box component={'div'} className="eMed_MobileNum_wrapper">
                {
                searchPatientData.length > 0 ?
                searchPatientData.map((list) => {
                    let PatientFullName = `${list.first_name} ${list.last_name}`
                    list["patient_name"] = PatientFullName
                    list["patient_mobile_number"] = list.mobile_number
                    list["patient_photo_url"] = list.photo_url
                    return (
                        <Box>
                        <Box className="eMed_Patient_Num_Search_pop">
                            <CommonPatientDetails data={list} />
                            <Tooltip title={"Proceed"} arrow>
                                <IconButton onClick={() => {
                                setSearchPatientData([])
                                setsearchPatient('')
                                checkPatientAbhaLink(list?.patient_account_number, list)
                                }} position="end">
                                <PersonAddAlt1Icon color='primary' />
                                </IconButton>
                            </Tooltip>
                        </Box>
                        <Divider />
                        </Box>
                    )
                    }) : null
                }
            </Box>
            </Box>
        </Modal>
        )
    }

    const validateAgreeName = (value) => {
        if (value?.length < 8) return 'Minimum 8 characters required.';
        if (value?.length > 18) return 'Maximum 18 characters allowed.';
        if (!/^[a-zA-Z0-9._]+$/.test(value)) return 'Only letters, numbers, dot (.) and underscore (_) are allowed.';
        if (/^[._]/.test(value) || /[._]$/.test(value)) return 'Dot or underscore cannot be at the start or end.';
        
        const dotCount = (value?.match(/\./g) || []).length;
        const underscoreCount = (value?.match(/_/g) || []).length;
        if (dotCount > 1 || underscoreCount > 1) return 'Only one dot (.) and one underscore (_) allowed.';

        return ''; // valid
    };

    const renderSuggestionPopup = () => {
        try {
            return (
                <Modal open={true} onClose={() => setSuggetionPop(false)}>
                    <Box sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        bgcolor: 'background.paper',
                        boxShadow: 24,
                        p: 4,
                        minWidth: "50vw",
                    }}>
                        <Box component={'div'} display={'flex'} justifyContent={'space-between'} alignItems={'center'} p={'0.5vw'} borderBottom={'1px solid lightgray'}>
                            <Typography variant="h6">Create ABHA Address</Typography>
                            <Button
                                className="Common_Btn_Min_Width"
                                onClick={() => {
                                // setSuggetionPop(false)
                                // setAddressApproved(true)
                                // setPatientDetails({
                                //     ...patientData,
                                //     phrAddress: [patientData?.preferredAddress || patientData?.phrAddress?.[0]]
                                // });
                                formAllClear()
                            }}
                            >
                                <Box component={'img'} src={ImagePaths.LabCloseButton.default} height={'1vw'} width={'1vw'} />
                            </Button>
                        </Box>
                        <Typography variant="body1" mb={2} mt={1}>
                            Preferred ABHA Address: <strong>{patientData?.preferredAddress || patientData?.phrAddress[0]}</strong>
                        </Typography>
                        <Grid container spacing={2} alignItems="center">
                            <Grid item xs={6}>
                                <TextField
                                    label="Type Custom ABHA Address"
                                    size="small"
                                    fullWidth
                                    value={customAddress}
                                    disabled={selectedSuggestion}
                                    onChange={e => {
                                        const value = e.target.value;
                                        setCustomAddress(value);
                                        setCustomNameError(validateAgreeName(value));
                                    }}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <Autocomplete
                                    size="small"
                                    options={suggetionData || []}
                                    getOptionLabel={option => typeof option === 'string' ? option : option.label || ""}
                                    renderInput={(params) => (
                                        <TextField {...params} label="ABHA Suggestions" fullWidth />
                                    )}
                                    value={selectedSuggestion}
                                    disabled={!selectedSuggestion && customAddress}
                                    onChange={(e, value) => {
                                        setSelectedSuggestion(value);
                                        if (value && typeof value === 'object') {
                                            setCustomAddress(value.label || "");
                                            setCustomNameError(validateAgreeName(value.label));
                                        } else {
                                            setCustomAddress(value || "");
                                            setCustomNameError(validateAgreeName(value));
                                        }
                                    }}
                                />
                            </Grid>
                        </Grid>
                        {/* Error Box for validateAgreeName */}
                        <Box mt={2} p={2} sx={{ border: '1px solid #eee', borderRadius: 2, background: '#fafafa' }}>
                            <Typography variant="subtitle2" mb={1}>ABHA Address Rules:</Typography>
                            {(() => {
                                const value = customAddress;
                                const rules = [
                                    { test: v => v.length >= 8, label: 'Minimum 8 characters required.' },
                                    { test: v => v.length <= 18, label: 'Maximum 18 characters allowed.' },
                                    { test: v => /^[a-zA-Z0-9._]+$/.test(v), label: 'Only letters, numbers, dot (.) and underscore (_) are allowed.' },
                                    { test: v => !/^[._]/.test(v) && !/[._]$/.test(v), label: 'Dot or underscore cannot be at the start or end.' },
                                    { test: v => (v.match(/\./g) || []).length <= 1 && (v.match(/_/g) || []).length <= 1, label: 'Only one dot (.) and one underscore (_) allowed.' },
                                ];
                                return rules.map((rule, idx) => (
                                    <Typography key={idx} sx={{ color: value ? rule.test(value) ? 'success.main' : 'error.main' : "text.primary", fontWeight: value ? rule.test(value) ? 400 : 700 : 400 }}>
                                        {rule.label}
                                    </Typography>
                                ));
                            })()}
                        </Box>
                        <Box mt={2} display="flex" justifyContent="space-between">
                            <Button sx={{textTransform:'capitalize'}} onClick={() => {
                                setSuggetionPop(false)
                                setAddressApproved(true)
                                setPatientDetails({
                                    ...patientData,
                                    phrAddress: [patientData?.preferredAddress || patientData?.phrAddress?.[0]]
                                });
                            }} variant="contained" color="primary">
                                Skip to Preferred ABHA Address
                            </Button>
                            <Button sx={{textTransform:'capitalize'}} onClick={postCustomAddress} disabled={!customAddress || customNameError} variant="contained" color="primary">
                                Proceed
                            </Button>
                        </Box>
                    </Box>
                </Modal>
            )
    }catch (error) {
            return null;
    }
    }

    return (
        <div style={{ padding: "20px", margin: "auto", backgroundColor: "#fff", height: "80vh" }}>
            <div style={{ height: "65vh" }}>
                <Grid container spacing={2} alignItems="center">
                    {/* <Grid item xs={5}>
                        <FormControl fullWidth >
                            <InputLabel id="patient-type">Patient Type</InputLabel>
                            <Select 
                            labelId="patient-type"
                            id="patient-type"
                            label="Patient Type"
                            value={patientType} 
                            disabled={addressApproved}
                            onChange={(e) => setpatientType(e.target.value)} 
                            size="small">
                                <MenuItem value="New">NEW PATIENT</MenuItem>
                                <MenuItem value="Existing">EXISTING PATIENT</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid> */}
                     {patientType === "Existing" ?
                        <Grid item xs={5} >
                            <TextField
                                size="small"
                                label="Search Patient & Click Enter"
                                value={searchPatient}
                                disabled={addressApproved}
                                onChange={(e) => {
                                    setsearchPatient(e.target.value)
                                    setPatientID(null)
                                    setSearchPatientData([])
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                        getPatientlist();
                                    }
                                }}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton onClick={getPatientlist} edge="end">
                                                <SearchIcon />
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                }}
                                fullWidth
                            />
                        </Grid> 
                        : null} 
                </Grid>
                {PatientID && (
                    <Grid container spacing={2} alignItems="center" mt={'1vh'}>
                        <Grid item xs={5}>
                        <TextField
                            size="small"
                            label="PatientName"
                            value={seachedPatient}
                            fullWidth
                            disabled={true}
                        />
                        </Grid>
                        <Grid item xs={5}>
                        <TextField
                            size="small"
                            label="UHID"
                            disabled={true}
                            value={PatientID}
                            fullWidth
                        />
                        </Grid>
                    </Grid>
                )}

                <Grid container spacing={2} alignItems="center" mt={'1vh'}>
                    <Grid item xs={5}>
                        {registrationType === "new" ?
                            <TextField
                                size="small"
                                label="Aadhaar Number"
                                disabled={addressApproved}
                                value={aadhaar}
                                error={aadhaarError}
                                helperText={aadhaarError ? "Please enter a valid Aadhaar number to proceed." : ""}
                                onChange={handleAadhaarChange}
                                fullWidth
                                placeholder="XXXX XXXX XXXX"
                                // inputProps={{ maxLength: 14 }}
                                // type={aadhaarMasked ? "password" : "text"}
                                type = {"text"}
                                inputProps={{
                                    maxLength: 14,
                                    inputMode: "numeric",
                                    autoComplete: "off",
                                    style: {
                                        WebkitTextSecurity: aadhaarMasked ? "disc" : "none"
                                    }
                                }}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton
                                                aria-label={aadhaarMasked ? "Show Aadhaar" : "Hide Aadhaar"}
                                                onClick={() => setAadhaarMasked((prev) => !prev)}
                                                edge="end"
                                            >
                                                {aadhaarMasked ? <VisibilityOffIcon /> : <VisibilityIcon />}
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                }}
                            /> :
                            <TextField
                                size="small"
                                label={(verifyWith === "AADHAAR") ? "Aadhaar Number" : "Mobile Number"}
                                value={VerifyInput}
                                onChange={(e) => handleVerifyInputChange(e.target.value)}
                                fullWidth
                                inputProps={{ maxLength: ((verifyWith === "AADHAAR") || (verifyWith === "ABHA")) ? 14 : 10 }}
                            />}
                    </Grid>
                    {/* <Grid item xs={5} display={"flex"} flexDirection={"row"} justifyContent={"space-evenly"}>
                        {registrationType === "new" && (
                            <TextField
                                size="small"
                                label="Mobile Number"
                                value={mobile}
                                onChange={(e) => handleMobileChange(e.target.value)}
                                placeholder="10 digit Mobile Number"
                                inputProps={{ maxLength: 10 }}
                                fullWidth
                                disabled={!otpSent}
                            />
                        )}
                        <TextField
                            size="small"
                            label="Enter OTP"
                            value={otp}
                            onChange={(e) => setOtp(e.target.value)}
                            sx={{ marginLeft: "2vw" }}
                            fullWidth
                            disabled={!otpSent}
                            inputProps={{ maxLength: 6 }}
                        />
                    </Grid> */}
                </Grid>

                <Grid container spacing={2} alignItems="center" style={{ marginTop: 10 }}>
                    <Grid item xs={5}>
                            {/* <FormControlLabel
                               control={
                                    <Checkbox
                                        checked={termsAccepted}
                                         onChange={(e) => setTermsAccepted(e.target.checked)}
                                     />
                                 }
                                 label="Terms & Conditions"
                            /> */}
                            <Box display="flex" alignItems="center">
                                {/* <Checkbox checked={termsAccepted} disabled /> */}
                                <Typography
                                    sx={{ cursor: "pointer", textDecoration: "underline", color: "primary" }}
                                    onClick={() => {
                                        if (aadhaar.length < 14) {
                                            setAadhaarError(true);
                                        }else if(addressApproved){}else{
                                            openTermsPopup();
                                        }
                                    }}
                                >
                                    Terms & Conditions
                                </Typography>
                            </Box>  
                        {/* <Button
                            variant="contained"
                            color="primary"
                            onClick={
                                () => {
                                    if (counter === 0 & otpSent){ handleGenerateOtp(1)
                                    } else { handleGenerateOtp() }
                            
                                }}
                            disabled={(!termsAccepted || (aadhaar.length < 14) || btnDisable || (counter > 0) || (resendCount > 1) || otpVerified)}
                            style={{ marginLeft: 10 }}
                        >
                            {otpSent && counter > 0 ? `Resend OTP (${counter}s)` : otpSent ? "Re Send" : "GET OTP"}
                        </Button> */}
                        {/* {otpSent ? (
                        <Typography
                            variant="caption"
                            color="textSecondary"
                            sx={{ display: "block", marginTop: "4px", marginLeft: "10px" }}
                        >
                            Remaining resend OTP: {resendCount + " / 2"}
                        </Typography>
                        ) : null} */}
                    </Grid>
                    {/* <Grid item xs={5}>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={handleVerifyOtp}
                            disabled={((otp.length !== 6) || btnDisable || otpVerified)}
                        >
                            VERIFY OTP
                        </Button>
                    </Grid> */}
                </Grid>

                {otpVerified && patientData && addressApproved && (
                    <Grid container spacing={2} style={{ marginTop: 20 }}>
                        <Grid item xs={6}>
                            <Typography variant="subtitle1"><strong>Patient Details</strong></Typography>
                            <Typography>Name: {[patientData?.firstName, patientData?.middleName, patientData?.lastName].filter(Boolean).join(" ")}</Typography>
                            <Typography>Gender: {patientData?.gender}</Typography>
                            <Typography>DOB: {patientData?.dob}</Typography>
                            <Typography>Mobile: {patientData?.mobile}</Typography>
                            <Typography>Address: {patientData?.address}</Typography>
                            <Typography>District: {patientData?.districtName}</Typography>
                            <Typography>State: {patientData?.stateName}</Typography>
                            <Typography>Pincode: {patientData?.pinCode}</Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <Typography variant="subtitle1"><strong>ABHA Details</strong></Typography>
                            <Box display="flex" alignItems="center" gap={1}>
                                <Typography>ABHA Address: {typeof(patientData?.phrAddress) === "string" ? patientData?.phrAddress : patientData?.phrAddress[0]}</Typography>
                                <Tooltip title={copiedField === "abha_address" ? "Copied!" : "Copy"}>
                                    <IconButton onClick={() => handleCopy(patientData?.phrAddress, "abha_address")} color="primary" size="small">
                                        <ContentCopyIcon fontSize="small" />
                                    </IconButton>
                                </Tooltip>
                            </Box>
                            <Box display="flex" alignItems="center" gap={1}>
                                <Typography>ABHA Number: {patientData?.ABHANumber}</Typography>
                                <Tooltip title={copiedField === "abha_number" ? "Copied!" : "Copy"}>
                                    <IconButton onClick={() => handleCopy(patientData?.ABHANumber, "abha_number")} color="primary" size="small">
                                        <ContentCopyIcon fontSize="small" />
                                    </IconButton>
                                </Tooltip>
                            </Box>
                            <Typography>ABHA Status: {patientData?.abhaStatus}</Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <img
                                src={patientData?.photo ? `data:image/jpeg;base64,${patientData.photo}` : ""}
                                alt="Patient"
                                style={{ width: 100, height: 120, borderRadius: 5 }}
                            />
                        </Grid>
                    </Grid>
                )}
            </div>
            <div style={{ height: "15vh" }}>
                <Grid container justifyContent="end" style={{ marginTop: '2vh' }}>
                    <Button variant='outlined' color="primary" style={{marginRight: '1.5vw', textTransform:'capitalize'}} onClick={() => {
                        formAllClear()
                    }}>
                        Clear
                    </Button>
                    <Button variant="contained" color="primary" style={{marginRight: '1.5vw', textTransform:'capitalize'}} onClick={() => {
                        downloadAbhaCard()
                    }} disabled={!addressApproved}>
                        Download ABHA Card
                    </Button>
                    <Button sx={{textTransform:'capitalize'}} variant="contained"
                        color="primary"
                        disabled={!addressApproved}
                        onClick={() => {
                            registerAbhaPatient()
                        }}
                    >
                        Register
                    </Button>
                </Grid>
            </div>
            {suggetionPop ?
            renderSuggestionPopup() : null}
            {searchPatientData && searchPatientData?.length > 0 ? patientListPopup() : null}
            {(isErrorStatus && errorMsg )?
            <ToastMsg
            severity={'error'}
            msg={errorMsg}
            msgPop={msgClose}
            />
            : null}
            {(isSuccStatus && succMsg)?
            <ToastMsg
            severity={'success'}
            msg={succMsg}
            msgPop={msgClose}
            />
            : null}
            {isRegistered ?
            <ConfirmPopup
                cnfAlertPopupClose={() => formAllClear()}
                cnfTitle={"Patient Registered Successfully"}
                cnfAbhaRegister={popupData}
                btnText1={"OK"}
                btnText2={"Download ABHA"}
                cnfData = {downloadAbhaCard}
            />
            : null}
            {alertPopup ?
                <ConfirmPopup
                    cnfTitle={'Confirmation'}
                    cnfContent={'Are you sure, Do you want to close? All the entered data will be lost.'}
                    cnfAlertPopupClose={() => setAlertPopup(false)}
                    cnfData={formAllClear}
                />
                : null}
            <Modal open={termsPopupOpen} onClose={handleClose}>
            <Box sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                bgcolor: 'background.paper',
                boxShadow: 24,
                p: 4,
                minWidth: '50vw',
                width: '90vw',
                maxWidth: "70vw",
                // maxHeight: '90vh',
                // overflowY: 'auto',
                borderRadius: 2
            }}>
                    <Box component={'div'} display={'flex'} justifyContent={'space-between'} alignItems={'center'} p={'0.5vw'} borderBottom={'1px solid lightgray'}>
                        <Typography variant="h6">Create ABHA Number</Typography>
                        <IconButton color="primary" curser="pointer" onClick={() => handleClose()} >
                            <img style={{ width: '2vw', height: '2vh' }} src={ImagePaths.Close.default} alt='close' />
                        </IconButton>
                    </Box>
                {isLoader && (
                <Box
                    sx={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    bgcolor: 'rgba(255,255,255,0.5)',
                    zIndex: 10,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderRadius: 2
                    }}
                >
                    <CircularProgress />
                </Box>
                )}
                <Box mb={2}>
                    <Box display="flex" alignItems="center" mt={1}>
                        <Box sx={{
                        width: 24, height: 24, borderRadius: '50%', bgcolor: termsStepperStep === 0 ? 'primary.main' : '#ccc', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1
                        }}>1</Box>
                        <Typography variant="body2" color={termsStepperStep === 0 ? 'primary.main' : 'text.secondary'}>Consent Collection</Typography>
                        <Box sx={{ width: 32, height: 2, bgcolor: '#ccc', mx: 1 }} />
                        <Box sx={{
                        width: 24, height: 24, borderRadius: '50%', bgcolor: termsStepperStep === 1 ? 'primary.main' : '#ccc', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1
                        }}>2</Box>
                        <Typography variant="body2" color={termsStepperStep === 1 ? 'primary.main' : 'text.secondary'}>Aadhaar Authentication</Typography>
                    </Box>
                </Box>  
                {termsStepperStep === 0 && (
                <>
                <Box
                sx={{
                    maxHeight: { xs: '50vh', md: '60vh' },
                    overflowY: 'auto', mb:2
                }}>
                    <Typography variant="subtitle1" fontStyle={"italic"} mb={1}>
                        Terms & Conditions
                    </Typography>
                {/* <Typography variant="h6" mb={2}>Terms & Conditions</Typography> */}
                {/* <Box
                sx={{
                    maxHeight: { xs: '50vh', md: '60vh' },
                    overflowY: 'auto',
                    mb: 2
                }}
                > */}
                {["I am voluntarily sharing my Aadhaar Number / Virtual ID issued by the Unique Identification Authority of India (UIDAI), and my demographic information for the purpose of creating an Ayushman Bharat Health Account number (ABHA number) and Ayushman Bharat Health Account address (ABHA Address). I authorize NHA to use my Aadhaar number / Virtual ID for performing Aadhaar based authentication with UIDAI per the provisions of the Aadhaar (Targeted Delivery of Financial and other Subsidies, Benefits and Services) Act, 2016 for the aforesaid purpose. I understand that UIDAI will share my e-KYC details, or response of 'Yes' with NHA upon successful authentication.", "I intend to create Ayushman Bharat Health Account Number (ABHA Number) and Ayushman Bharat Health Account address using document other than Aadhaar", "I consent to usage of my ABHA address and ABHA number for linking of my legacy (past) health records and those which will be generated during this encounter.", "I authorize the sharing of all my health records with healthcare provider(s) for the purpose of providing healthcare services to me during the encounter.", "I consent to the anonymization and subsequent use of my health records for public health purposes."].map((term, idx) => (
                <Box key={idx} display="flex" alignItems="center" mb={1}>
                    <Checkbox
                    checked={termsChecks[idx]}
                    onChange={e => {
                        const newChecks = [...termsChecks];
                        newChecks[idx] = e.target.checked;
                        setTermsChecks(newChecks);
                        if (!e.target.checked) setTermsAccepted(false);
                    }}
                    />
                    <Typography>{term}</Typography>
                </Box>
                ))}
                <Box display="flex" alignItems="flex-start" mb={1}>
                <Checkbox
                    checked={termsChecks[5]}
                    onChange={e => {
                    const newChecks = [...termsChecks];
                    newChecks[5] = e.target.checked;
                    setTermsChecks(newChecks);
                    if (!e.target.checked) setTermsAccepted(false);
                    }}
                    sx={{ mt: 0.5 }}
                />
                <Typography component="div" sx={{ lineHeight: 2 }}>
                    I {loginName} confirm that I have duly informed and explained the beneficiary of the contents of consent for aforementioned purposes.
                </Typography>
                </Box>
                <Box display="flex" alignItems="flex-start" mb={1}>
                <Checkbox
                    checked={termsChecks[6]}
                    onChange={e => {
                    const newChecks = [...termsChecks];
                    newChecks[6] = e.target.checked;
                    setTermsChecks(newChecks);
                    if (!e.target.checked) setTermsAccepted(false);
                    }}
                    sx={{ mt: 0.5 }}
                />
                <Typography component="div" sx={{ lineHeight: 2 }}>
                    I,&nbsp;
                    <Box component="span" sx={{ display: 'inline-block', width: 120, verticalAlign: 'bottom' }}>
                    <TextField
                        size="small"
                        value={agreeName}
                        variant="standard"
                        onChange={e => setAgreeName(e.target.value)}
                        fullWidth
                    />
                    </Box>
                    &nbsp;, have been explained about the consent as stated above and hereby provide my consent for the aforementioned purposes.
                </Typography>
                </Box>
                {/* </Box> */}
                <Divider sx={{ my: 1 }} />
                {/* <Typography variant="subtitle2" mb={1}>Captcha</Typography> */}
                <Box display="flex" alignItems="center" gap={2} mb={1} flexDirection={"row"} >
                <Box sx={{
                    px: 2, py: 1, bgcolor: "#eee", borderRadius: 1, fontWeight: "bold", letterSpacing: 2, fontSize: 18, textDecoration: "line-through", fontStyle: "italic", color: "#555", userSelect: "none", transform: "rotate(-5deg)", filter: "blur(0.5px)"
                }}>{captcha}</Box>
                {/* <Button size="small" onClick={() => setCaptcha(generateCaptcha())}>Refresh</Button> */}
                <IconButton
                aria-label="Refresh Captcha"
                onClick={() => setCaptcha(generateCaptcha())}
                size="small"
                >
                <RefreshIcon color="primary" />
                </IconButton>
                <TextField
                label="Enter Captcha"
                value={captchaInput}
                size="small"
                onChange={e =>{
                    const value = e.target.value.toUpperCase();
                    setCaptchaInput(value);
                    if (value !== captcha) setTermsAccepted(false);
                }}
                // fullWidth
                />
                </Box>
                </Box>
                <Divider sx={{ my: 1 }} />
                <Box display="flex" justifyContent="flex-end">
                <Button
                sx={{textTransform:'capitalize'}}
                variant="contained"
                color="primary"
                // fullWidth
                disabled={
                    !termsChecks.every(Boolean) ||
                    (captchaInput !== captcha) || !agreeName
                }
                onClick={() => {
                    // setTermsAccepted(true);
                    // setTermsPopupOpen(false);
                    handleGenerateOtp()
                }}
                >
                Get OTP
                </Button>
                </Box>
            </>
            )}  
            {termsStepperStep === 1 && (
                <>
                    <Typography variant="subtitle1" mb={1}>
                    {adhaarMobMsg}
                    </Typography>
                    <TextField
                    label="Enter OTP"
                    size="small"
                    value={otp}
                    disabled={comMob2}
                    onChange={e => {
                        const val = e.target.value.replace(/\D/g, '').slice(0, 6);
                        setOtp(val);
                    }}
                    // fullWidth
                    sx={{ mb: 1 }}
                    inputProps={{ maxLength: 6 }}
                    />
                    <Box sx={{ display: "flex", justifyContent: "flex-start",flexDirection: "row", gap: 2 }}>
                    <Typography variant="subtitle1" mb={1} >
                    {"Didn't receive OTP?"}   
                    </Typography>
                    {/* <Box> */}
                    <Button
                    variant="contained"
                    color="primary"
                    // fullWidth
                    size="small"
                    sx={{ mb: 1, textTransform:'capitalize' }}
                    disabled={counter > 0 || comMob2 || resendCount >= 2}
                    onClick={() => {
                        setOtpSent(true);
                        setCounter(59);
                        handleGenerateOtp(1)

                    }}
                    >
                    {otpSent && counter > 0 ? `Resend OTP (${counter}s)` : otpSent ? "Resend OTP" : "Get OTP"}
                    </Button>
                    {/* {otpSent ? ( */}
                    <Typography
                        variant="caption"
                        color="textSecondary"
                        sx={{ display: "block", marginTop: "4px" }}
                    >
                        Remaining resend OTP: {resendCount + " / 2"}
                    </Typography>
                    
                    {/* ) : null} */}
                    {/* </Box> */}
                    </Box>
                    <Divider />
                    <Typography variant="subtitle1" mb={1}>
                    {"Enter Communication Mobile Number"}
                    </Typography>
                    <TextField
                    label="Mobile Number"
                    size="small"
                    value={mobile}
                    disabled={comMob2}
                    onChange={(e) => handleMobileChange(e.target.value)}
                    placeholder="10 digit Mobile Number"
                    // fullWidth
                    inputProps={{ maxLength: 10 }}
                    InputProps={{
                        startAdornment: (
                        <InputAdornment position="start">
                            <Box
                            sx={{
                                bgcolor: "#f0f0f0",
                                px: 0.5,
                                py: 0.5,
                                borderRadius: 1,
                                fontWeight: 500,
                                color: "#555",
                                fontSize: 16,
                                minWidth: 38,
                                textAlign: "center"
                            }}
                            >
                            +91
                            </Box>
                        </InputAdornment>
                        )
                    }}                 
                    />
                    {/* <Typography variant="subtitle1" fontStyle={"italic"} fontSize={"0.8vw"}>
                    {"Prefer using your Aadhaar-linked mobile number."}
                    </Typography>
                    <Typography variant="subtitle1" mb={1} fontStyle={"italic"} fontSize={"0.8vw"}>
                    {"validation is required to use a different mobile number for ABHA communications."}
                    </Typography> */}
                    {comMob2 && (
                        <Box sx={{ display: "flex", flexDirection: "column"}}>
                        <Typography variant="subtitle1"  mb={1}>
                        {comMobMsg}
                        </Typography>
                        <TextField
                        label="Enter OTP"
                        size="small"
                        value={otp2}
                        onChange={e => {
                            const val = e.target.value.replace(/\D/g, '').slice(0, 6);
                            setOtp2(val);
                        }}
                        // fullWidth
                        sx={{ mb: 1 }}
                        inputProps={{ maxLength: 6 }}
                        />
                        <Box sx={{ display: "flex", justifyContent: "flex-start",flexDirection: "row", gap: 2 }}>
                            <Typography variant="subtitle1" mb={1} fontStyle={"italic"} >
                            {"Didn't receive OTP?"}   
                            </Typography>
                            {/* <Box> */}
                            <Button
                            variant="contained"
                            color="primary"
                            // fullWidth
                            size="small"
                            sx={{ mb: 1, textTransform:'capitalize' }}
                            disabled={counter2 > 0}
                            onClick={() => {
                                setOtpSent2(true);
                                setCounter2(59);
                                handleGenerateOtp(1, "comMob2")

                            }}
                            >
                            {otpSent2 && counter2 > 0 ? `Resend OTP (${counter2}s)` : "Re Send"}
                            </Button>
                            {/* {otpSent ? ( */}
                            <Typography
                                variant="caption"
                                color="textSecondary"
                                sx={{ display: "block", marginTop: "4px" }}
                            >
                                Remaining resend OTP: {resendCount2 + " / 2"}
                            </Typography>
                            
                            {/* ) : null} */}
                            {/* </Box> */}
                        </Box>
                        </Box>
                    )}
                    <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 1 }}>
                    <Button
                    sx={{textTransform:'capitalize'}}
                    variant="contained"
                    color="primary"
                    // fullWidth
                    size="small"
                    disabled={((otp.length !== 6) || mobile.length !== 10) || (comMob2 && otp2.length !== 6)}
                    onClick={() => {
                        if (comMob2) {
                            handleVerifyOtp("comMob2");
                        } else {
                            handleVerifyOtp();
                        }
                    }}
                    >
                    Verify OTP
                    </Button>
                    </Box>
                </>
            )}
            </Box>
            </Modal>
            <Loader loaderOpen={isLoader} />
        </div>
    );
};

export default AbhaRegister;
